type GetSearchValue = (location: string, key?: string) => string | undefined;

export const getSearchValue: GetSearchValue = (location, key) => {
  const search = location
    .replace('?', '')
    .split('&')
    .map((query) => ({ [query.split('=')[0]]: query.split('=')[1] }));

  const result = key ? search.find((query) => query[key])?.[key] : undefined;
  return result;
};
